import { useContext, useEffect } from 'react';
import usePostMessage from 'hooks/utils/usePostMessage';
import { useIntl } from 'react-intl';
import messages from 'messages';
import { Panel } from 'components/panel';
import { useParams, useRouteMatch } from 'react-router-dom';
import { ROUTE_USER_ENTITY_PROGRAMS } from 'routes/RouteList';
import PersonPrograms from 'containers/pages/person/programs/components/PersonPrograms';
const OverView = () => {
  const { sendMessage } = usePostMessage();
  const intl = useIntl();
  const { entityId } = useParams();

  const active = useRouteMatch([ROUTE_USER_ENTITY_PROGRAMS]);

  useEffect(() => {
    const data = {
      title: intl.formatMessage(messages.programs),
      description: intl.formatMessage(messages.programsSubtitleAll),
      canGoBack: false
    };
    sendMessage({ message: data });
  }, []);

  return (
    <Panel active={active?.isExact}>
      <PersonPrograms entityId={entityId} />
    </Panel>
  );
};

export default OverView;
